module.exports = __webpack_public_path__ + "img/icon_dmain2.d6482393.png";